<template>
    <CountrySelect
        v-bind="$attrs"
        :code="value"
        data-cy="country-select"
        :data-cy-data="inputCode"
        :country-codes-list="countryCodesList"
        :order-by-loco="orderByLoco"
        @change="
            (code) => {
                inputCode = code;
                $emit('input', code);
            }
        "
    />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CountrySelect } from '@arena/toolkit';

export default {
    name: 'CountrySelector',
    components: { CountrySelect },
    props: {
        value: {
            type: String,
            default: null,
        },
        orderByLoco: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            inputCode: '',
        };
    },
    computed: {
        ...mapState('country', ['ipCountryCode', 'countryCodes', 'ipMembershipNo']),
        hasFromOPENAPI_WEBSITE() {
            if (typeof window.sessionStorage !== 'undefined') {
                return !!window.sessionStorage.getItem('from_openapi_website');
            }
            return false;
        },
        countryCodesList() {
            let countryCodes = this.countryCodes;
            if (this.isUnified) {
                countryCodes.sort((a, b) =>
                    this.$t(`_common.country-list.${a.code}`).localeCompare(this.$t(`_common.country-list.${b.code}`))
                );
                const sorted = new Set();
                countryCodes.filter((x) => x.membershipNo === this.ipMembershipNo).forEach((x) => sorted.add(x));
                countryCodes.forEach((x) => sorted.add(x));
                countryCodes = Array.from(sorted);
            }
            return countryCodes.map((x) => x.code);
        },
        isUnified() {
            return this.$router.currentRoute.query.unified || this.$router.currentRoute.name.indexOf('unified') > -1;
        },
    },
    async mounted() {
        await this.getCountryInfo();
        if (this.countryCodesList.includes(this.ipCountryCode) && !this.value) {
            this.$emit('input', this.ipCountryCode);
        }
    },
    methods: {
        ...mapActions('country', ['getCountryInfo']),
    },
};
</script>
